import { render } from "./DataSetsOverview.vue?vue&type=template&id=81e56ad8"
import script from "./DataSetsOverview.vue?vue&type=script&lang=js"
export * from "./DataSetsOverview.vue?vue&type=script&lang=js"

import exportComponent from "/builds/dock/research/autocbm/autocbm-ui/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__